import { ClawMark } from "./Brand";

const ITEMS = ["Aniversários", "Casamentos", "15 anos", "Eventos corporativos", "Jogadas ilimitadas", "Diversão para todas as idades"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section aria-label="Tipos de evento" data-testid="marquee" className="relative py-10 border-y border-white/5 bg-[#0B0B11] overflow-hidden">
      <div className="flex w-max marquee-track">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center shrink-0">
            {row.map((t, i) => (
              <span key={`${k}-${i}`} className="flex items-center">
                <span className={`font-display font-black uppercase text-4xl md:text-6xl px-8 whitespace-nowrap ${i % 2 ? "text-stroke" : "text-white"}`}>{t}</span>
                <ClawMark className="w-10 h-10 md:w-14 md:h-14 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
